import React, { useState } from "react";
import * as Icons from "react-feather";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import axios from "axios";
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import { ReactComponent as SortArrow } from '../../shared/img/chevron-up-down.svg';
import ClientModel from "./models/ClientModel";
import ClientModal from "../clients/ClientModal";
import { Rating } from 'react-simple-star-rating';
import { ConvertArrayToXML, getStorageValues } from "../../shared/CommonFunctions";
import { getApiBaseUrl } from "../../utils/apiConfig";
function ClientGrid(props) {
  const [actionType, setActionType] = useState("");
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [clientModel, setClientModel] = useState(new ClientModel());
  const [filterText, setFilterText] = React.useState("");
  const [alert, setAlert] = useState(null);

  function closeModal() {
    setIsOpen(false);
    props.fetchClients();
  }

  const rows = props.ClientData
    ? props.ClientData.filter(
      (item) =>
      (item.ClientName &&
        item.ClientName.toLowerCase().includes(filterText.toLowerCase()))
    )
    : [];

  const openActionType = (row, name) => {
    setClientModel(row);
    setIsOpen(true);
    setActionType(name);
  };
  async function onSubmit(e, data) {
    const clientModel = data;
    if (e.target.name === "Edit") {
      let clientDetails = {
        ClientId: clientModel.ClientId,
        TaxStatusId: clientModel.TaxStatusId,
        ModeOfHoldingId: clientModel.ModeOfHoldingId,
        ClientRatingsId: clientModel.ClientRatingsId,
        ReferedBy: clientModel.ReferedBy,
        TitleId: clientModel.TitleId,
        ClientName: clientModel.ClientName,
        FamilyHeadId: clientModel.FamilyHeadId,
        GenderId: clientModel.GenderId,
        EmailId: clientModel.EmailId,
        MobileNumber: clientModel.MobileNumber,
        DateOfBirth: clientModel.DateOfBirth,
        DateOfAnniversary: clientModel.DateOfAnniversary,
        PlaceOfBirth: clientModel.PlaceOfBirth,
        CountryOfBirth: clientModel.CountryOfBirth,
        Occupation: clientModel.Occupation,
        PANNo: clientModel.PANNo,
        Nominee: clientModel.Nominee,
        Address: '<Addresses>' + ConvertArrayToXML(clientModel.Address, '<Address>') + '</Addresses>',
        ClientInvestment: clientModel.ClientInvestment,
        DPId: clientModel.DPId,
        NPSAccountNumber: clientModel.NPSAccountNumber,
        AnnualIncome: clientModel.AnnualIncome,
        GrossAnnualIncome: clientModel.GrossAnnualIncome,
        NetWorth: clientModel.NetWorth,
        BankName: clientModel.BankName,
        BranchName: clientModel.BranchName,
        AccountNumber: clientModel.AccountNumber,
        IFSCCode: clientModel.IFSCCode,
        LeadId: clientModel.LeadId,
        UserId: getStorageValues('userId')
      };
      if (validation(clientDetails)) {
        try {
          const response = await axios.post(
            getApiBaseUrl() + "/saveClientDetails",
            clientDetails
          );
          if (response.status === 200) {
            if (response.data.data[0].success === 1) {
              CreateAlert(response.data.data[0].message, "Success", setAlert);
              props.fetchClients();
              closeModal();
            } else {
              CreateAlert(response.data.data[0].message, "Warning", setAlert);
            }
          }
        } catch (error) {
          console.log(error);
          CreateAlert("There is some error. Please contact software support!!", "Warning", setAlert);
        }
      }
    } else if (e.target.name === "Delete") {
      let clientDetails = {
        ClientId: clientModel.ClientId
      };
      try {
        const response = await axios.post(
          getApiBaseUrl() + "/deleteclient", clientDetails
        );
        if (response.status === 200) {
          CreateAlert("Client company deleted successfully!!", "Success", setAlert);
          props.fetchClients();
          closeModal();
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  function validation(clientDetails) {
    var validation = true;
    if (clientDetails) {
      if (clientDetails.ClientName !== null) {
        if (clientDetails.ClientName.length === 0) {
          CreateAlert("Please enter client name!!", "Warning", setAlert);
          validation = false;
          return;
        }
      } else {
        CreateAlert("Please enter client name!!", "Warning", setAlert);
        validation = false;
        return;
      }
      if (clientDetails.TaxStatusId === null || clientDetails.TaxStatusId === undefined) {
        CreateAlert("Please select Tax status!!", "Warning", setAlert);
        validation = false;
        return;
      }
      if (clientDetails.TaxStatusId === 1) {
        if (clientDetails.GenderId === null || clientDetails.GenderId === undefined) {
          CreateAlert("Please select Gender!!", "Warning", setAlert);
          validation = false;
          return;
        }
      }
      if (clientDetails.EmailId === null || clientDetails.EmailId === undefined) {
        CreateAlert("Please enter email id!!", "Warning", setAlert);
        validation = false;
        return;
      }
      if (clientDetails.MobileNumber === null || clientDetails.MobileNumber === undefined) {
        CreateAlert("Please enter mobile number!!", "Warning", setAlert);
        validation = false;
        return;
      }
      if (clientDetails.PANNo === null || clientDetails.PANNo === undefined) {
        CreateAlert("Please enter PAN number!!", "Warning", setAlert);
        validation = false;
        return;
      }
      if (clientDetails.DateOfBirth === null || clientDetails.DateOfBirth === undefined) {
        CreateAlert("Please enter date of birth!!", "Warning", setAlert);
        validation = false;
        return;
      }
    } else {
      CreateAlert("Some proplem fatching user details entered by the user!!", "Error", setAlert);
      validation = false;
      return;
    }
    return validation;
  }

  const columns = [
    {
      name: <div className="titlename"><span>Client Name</span></div>,
      selector: row => row.ClientDisplayName,
      cell: (row) => (
        <span title={row.ClientDisplayName}>{row.ClientDisplayName}</span>
      ),
      sortable: true,
      sortIcon: <span > <SortArrow /></span>
    },
    {
      name: <div className="titlename"><span>Email</span></div>,
      selector: row => row.EmailId,
      cell: (row) => (
        <span title={row.EmailId}>{row.EmailId}</span>
      ),
      sortable: true,
      sortIcon: <span > <SortArrow /></span>
    },
    {
      name: <div className="titlename"><span>Mobile No</span></div>,
      selector: row => row.MobileNumber,
      cell: (row) => (
        <span title={row.MobileNumber}>{row.MobileNumber}</span>
      ),
      sortable: true,
      sortIcon: <span > <SortArrow /></span>
    },
    {
      name: <div className="titlename"><span>Client Ratings</span></div>,
      selector: row => row.ClientRating,
      cell: (row) => (
        row.ClientRating === null ? "" : <span style={{ fontSize: "10px", fontWeight: "bold" }}>{row.ClientRating} :
          <Rating
            initialValue={row.ClientRating === "VIP" ? "4.5" : row.ClientRating === "Average" ? "3.5" : row.ClientRating === "Prefer" ? "2.5" : "0"}
            readonly={true}
            size={23}
            allowFraction={true}
          />
        </span>
      ),
      sortable: true,
      sortIcon: <span > <SortArrow /></span>
    },
    {
      name: <div className="titlename"><span>Mode of Holding</span></div>,
      selector: row => row.ModeOfHolding,
      cell: (row) => (
        <span title={row.ModeOfHolding}>{row.ModeOfHolding}</span>
      )
    },
    {
      name: <div className="titlename"><span>Tax Status</span></div>,
      selector: row => row.TaxStatus,
      cell: (row) => (
        <span title={row.TaxStatus}>{row.TaxStatus}</span>
      )
    },
  ];
  if (props.UserPermissions.ViewModule === 1 || props.UserPermissions.EditModule === 1 || props.UserPermissions.DeleteModule === 1) {
    columns.push({
      name: <div className="titlename">Actions</div>,
      cell: (row) => (
        <div className="edit-delete-action">
          {
            props.UserPermissions.ViewModule === 1 ?
              <Link
                className="me-2 p-2"
                to=""
                onClick={() => {
                  openActionType(row, "View");
                }}
              >

                <Icons.Eye data-feather="eye" className="action-eye" />
              </Link>
              : null
          }

          {
            props.UserPermissions.EditModule === 1 ?
              <Link
                className="me-2 p-2"
                to=""
                onClick={() => {
                  openActionType(row, "Edit");
                }}
              >
                <Icons.Edit data-feather="edit" className="feather-edit" />
              </Link>
              : null
          }
          {
            props.UserPermissions.DeleteModule === 1 ?
              <Link
                className="confirm-text p-2"
                to=""
                onClick={() => {
                  openActionType(row, "Delete");
                }}
              >
                <Icons.Trash2 data-feather="trash-2" className="feather-trash-2" />
              </Link>
              : null
          }
        </div>
      ),
      center: "true",
      width: "200px"
    },);
  };




  return (
    <>
      <SKAlerts alert={alert} />
      <div className="card table-list-card">
        <div className="card-body">
          <div className="table-top">
            <div className="search-set">
              <div className="search-input">
                <button type="button" className="btn btn-searchset">
                  <Icons.Search className="feather-search" />
                </button>
                <input
                  id="search"
                  type="text"
                  className="form-control form-control-sm custom-search-input"
                  placeholder="Search"
                  aria-label="Search Input"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
              </div>
            </div>
          </div>
          <DataTable
            className="table-responsive product-list"
            columns={columns}
            data={rows}
            pagination
            sortIcon={<SortArrow />}
            persistTableHead={true}
          />
        </div>
      </div>
      <ClientModal
        show={modalIsOpen}
        UserAction={actionType}
        onClose={closeModal}
        selectedRow={clientModel}
        onSubmit={onSubmit}
        displayModule={props.displayModule}
      />

    </>
  );
}

export default ClientGrid;
